export const parseWorkspaceThemeConfig = (theme: unknown): Record<string, unknown> | null => {
    if (!theme) return null;

    if (typeof theme === 'string') {
        const trimmedTheme = theme.trim();
        if (!trimmedTheme) return null;

        let parsedTheme: unknown;
        try {
            parsedTheme = JSON.parse(trimmedTheme);
        } catch {
            return null;
        }

        if (!parsedTheme || typeof parsedTheme !== 'object' || Array.isArray(parsedTheme)) return null;
        return parsedTheme as Record<string, unknown>;
    }

    if (typeof theme === 'object' && !Array.isArray(theme)) {
        return theme as Record<string, unknown>;
    }

    return null;
};

export const shouldCacheWorkspaceThemeConfig = (theme: unknown, themeConfig: Record<string, unknown> | null) => {
    if (themeConfig) return true;
    if (theme == null) return true;
    if (typeof theme === 'string') return !theme.trim();
    return false;
};

export const shouldApplyAuthRequestResult = (requestGeneration: number, currentGeneration: number) => {
    return requestGeneration === currentGeneration;
};

export const shouldApplyWorkspaceScopedAuthRequestResult = (requestGeneration: number, currentGeneration: number, requestWorkspaceId = 0, currentWorkspaceId = 0) => {
    if (!shouldApplyAuthRequestResult(requestGeneration, currentGeneration)) return false;
    if (!requestWorkspaceId) return true;
    return requestWorkspaceId === currentWorkspaceId;
};

export const createAuthRequestKey = (requestGeneration: number, requestType: string, workspaceId = 0) => {
    return `${requestGeneration}:${workspaceId}:${requestType}`;
};

export const createInFlightRequestStore = <T>() => {
    const requests = new Map<string, Promise<T>>();

    return {
        run: (key: string, factory: () => Promise<T>) => {
            const currentRequest = requests.get(key);
            if (currentRequest) return currentRequest;

            const nextRequest = factory().finally(() => {
                if (requests.get(key) === nextRequest) {
                    requests.delete(key);
                }
            });

            requests.set(key, nextRequest);
            return nextRequest;
        },
        clear: () => {
            requests.clear();
        },
        size: () => requests.size,
    };
};

export const shouldResetAuthOnRefreshError = (status?: number) => {
    return status === 401 || status === 403;
};
